/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.toggle input[type="checkbox"] {
  width: 0px;
  height: 0px;
  display: none;
}
.toggle label {
  cursor: pointer;
  text-indent: calc(var(--spacing, 0.25rem) * -96);
  width: calc(var(--spacing, 0.25rem) * 11);
  height: calc(var(--spacing, 0.25rem) * 6);
  background-color: var(--color-neutral-300, oklch(87% 0 none));
  display: block;
  border-radius: var(--radius-xl, 0.75rem);
  position: relative;
}
.toggle label:after {
  content: "";
  position: absolute;
  background-color: var(--color-white, #fff);
  border-radius: var(--radius-xl, 0.75rem);
  width: calc(var(--spacing, 0.25rem) * 4);
  height: calc(var(--spacing, 0.25rem) * 4);
  right: calc(var(--spacing, 0.25rem) * 6);
  top: calc(50% - 0.5rem);
  --tw-duration: 200ms;
  transition-duration: 200ms;
  --tw-ease: var(--ease-in, cubic-bezier(0.4, 0, 1, 1));
  transition-timing-function: var(--ease-in, cubic-bezier(0.4, 0, 1, 1));
}
.toggle input:disabled + label {
  cursor: not-allowed;
  opacity: 30%;
}
.toggle input:checked + label {
  background-color: var(--color-primary-500);
}
.toggle input:checked + label:after {
  position: absolute;
  width: calc(var(--spacing, 0.25rem) * 4);
  height: calc(var(--spacing, 0.25rem) * 4);
  right: var(--spacing, 0.25rem);
  top: calc(50% - 0.5rem);
  --tw-duration: 200ms;
  transition-duration: 200ms;
  --tw-ease: var(--ease-in, cubic-bezier(0.4, 0, 1, 1));
  transition-timing-function: var(--ease-in, cubic-bezier(0.4, 0, 1, 1));
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
